import "./BomenInBelgië.scss";
import React, { useState, useEffect, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import intro from "../../Images/intro_bomen.png";
import tree from "./H4_boom leeg apart.png";
import boxes from "./H4_vakjes apart.png";
import zuurstofImage from "./H4_groot zuurstof.png";
import voedselImage from "./H4_groot voedsel.png";
import ontspanningImage from "./H4_groot ontspanning.png";
import houtImage from "./H4_groot hout.png";
import biodiversiteitImage from "./H4_groot biodiversiteit.png";
import papierImage from "./H4_groot papier.png";
import waterImage from "./H4_groot water.png";
import boomBio from "../../Images/boom-biodiversiteit.png";
import boomHout from "../../Images/boom-hout.png";
import boomOntspanning from "../../Images/boom-ontspanning.png";
import boomPapier from "../../Images/boom-papier.png";
import boomVoedsel from "../../Images/boom-voedsel.png";
import boomWater from "../../Images/boom-water.png";
import boomZuurstof from "../../Images/boom-zuurstof.png";

const BOX_TYPE = "BOX";

const Box = ({ item, isCompleted, onClick, onDrop }) => {
  const [, drop] = useDrop({
    accept: BOX_TYPE,
    drop: function (droppedItem) {
      onDrop(droppedItem);
    }
  });

  const style = {
    top: item.position.y + "px",
    left: item.position.x + "px",
    width: item.position.size + "px",
    height: item.position.size + "px",
    zIndex: "200"
  };

  if (isCompleted) {
    style.backgroundImage = `url("${item.img}")`;
    style.backgroundSize = "cover";
    style.backgroundPosition = "center center";
    style.backgroundRepeat = "no-repeat";
    style.backgroundColor = "white";
  }

  return (
    <div
      ref={drop}
      key={item.name}
      className="drop"
      onClick={onClick}
      style={style}
    />
  );
};

const DraggableImage = ({ item, onClick, onBeginDrag, big }) => {
  const [{ isDragging }, drag] = useDrag({
    item: { name: item.name, type: BOX_TYPE },
    begin: function () {
      onBeginDrag(item);
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  return (
    <div
      ref={drag}
      style={{ backgroundImage: `url("${big ? item.img : item.buttonImg}")` }}
      onClick={onClick}
    />
  );
};

const fout = {
  name: "Fout",
  buttonImg: waterImage,
  img: waterImage,
  position: { x: 104, y: 335, size: 46, right: 166 },
  description:
    "Oeps! Lijkt niet juist te zijn",
  completed: false
}

const items = [
  {
    index: 0,
    name: "Zuurstof",
    buttonImg: zuurstofImage,
    img: zuurstofImage,
    position: { x: 55, y: 72, size: 49, right: 215 },
    description:
      "Zonder bomen kunnen wij niet ademen! De bladeren zuiveren de lucht rondom ons.",
    completed: false
  },
  {
    index: 1,
    name: "Voedsel",
    buttonImg: voedselImage,
    img: voedselImage,
    position: { x: 212, y: 179, size: 37, right: 58 },
    description:
      "Hoog in de bomen vind je onder meer noten, appels, kersen en vlierbloesems. In de kruidlaag vind je bijvoorbeeld bosbossen, brandnetels, paddenstoelen en honing.",
    completed: false
  },
  {
    index: 2,
    name: "Ontspanning",
    buttonImg: ontspanningImage,
    img: ontspanningImage,
    position: { x: 14, y: 203, size: 34, right: 258 },
    description:
      "Bossen zijn de perfecte plaats om in te spelen, picknicken en ravotten.",
    completed: false
  },
  {
    index: 3,
    name: "Hout",
    buttonImg: houtImage,
    img: houtImage,
    position: { x: 103, y: 228, size: 34, right: 168 },
    description:
      "Het zwaarste deel van de boom gebruik je om meubelen te maken, vloeren te leggen en om je te verwarmen.",
    completed: false
  },
  {
    index: 4,
    name: "Biodiversiteit",
    buttonImg: biodiversiteitImage,
    img: biodiversiteitImage,
    position: { x: 178, y: 260, size: 26, right: 92 },
    description:
      "Bossen dienen als schuilplaats of nest voor dieren. Ze maken plaats voor planten die soms zelfs geneeskrachtig zijn.",
    completed: false
  },
  {
    index: 5,
    name: "Papier",
    buttonImg: papierImage,
    img: papierImage,
    position: { x: 136, y: 155, size: 34, right: 134 },
    description:
      "Als je het zwaarste deel van de boom vermaalt en bewerkt, kan je ze gebruiken om op te tekenen, als toiletpapier, om verpakkingen te maken, …",
    completed: false
  },
  {
    index: 6,
    name: "Water",
    buttonImg: waterImage,
    img: waterImage,
    position: { x: 104, y: 335, size: 46, right: 166 },
    description:
      "Onder de grond nemen bomen water op als het veel regent. Bomen zuiveren het water.",
    completed: false
  },
];

const BomenInBelgië = () => {
  const [completedItems, setCompletedItems] = useState({});
  const completedItemsRef = useRef(completedItems);
  const [highlightedItem, setHighlightedItem] = useState(items[0]);
  const [tooltipItem, setTooltipItem] = useState(null);
  const progress = Object.keys(completedItems).length / items.length;

  useEffect(() => {
    completedItemsRef.current = completedItems;
  });

  function handleCompletedItem(completedItem) {
    // Can't use completedItems here because it will point to old version of completedItems
    // See https://github.com/react-dnd/react-dnd/issues/1326
    // Workaround is to store completedItems in a ref, the ref doesn't change but it's value can
    setCompletedItems({
      ...completedItemsRef.current,
      [completedItem.name]: true
    });

    // set new highlighted item
    if (completedItem.index < 6) {
      setHighlightedItem(items[completedItem.index + 1]);
    } else {
      setHighlightedItem("")
    }
  }

  return (
    <div className="bomen-in-belgië">
      <div className="intro">
        <img src={intro} alt="Introductie" />
        <span>
          Jullie hebben in mijn verhaal en dat van Mayu gehoord dat de mensen en dieren in het Amazonewoud het bos nodig hebben, maar waarvoor hebben wij hier in België bomen nodig?
          <br /><br />
          Sleep de correcte pictogrammen naar het juiste onderdeel van de boom.
        </span>
      </div>
      <div className="flex-box">
        <div className="panel">
          <div className="highlighted">
            <DraggableImage
              key={highlightedItem.name}
              item={highlightedItem}
              big={true}
              onBeginDrag={itemBeingDragged => {
                setTooltipItem("");
                setHighlightedItem(itemBeingDragged);
              }}
            />
          </div>
          {highlightedItem.name && <div>
            <span className="name">{highlightedItem.name}</span>
          </div>}
          {highlightedItem.description && <div>
            <span className="description">{highlightedItem.description}</span>
          </div>}
          {/*<ul>
            {items.map(item => (
              <li
                onClick={() => {
                  setHighlightedItem(item);
                  setTooltipItem("");
                }}
                key={item.name}
                style={{
                  opacity: item.name in completedItems ? "1" : ""
                }}
                className={
                  highlightedItem.name === item.name ? "is-highlighted" : ""
                }
              >
                <DraggableImage
                  item={item}
                  onBeginDrag={itemBeingDragged => {
                    setTooltipItem("");
                    setHighlightedItem(itemBeingDragged);
                  }}
                />
              </li>
            ))}
            </ul>*/}
        </div>
        <div className="tree-container">
          <div className="tree" style={{ backgroundImage: `url("${tree}")` }} />
          <div className="tree-parts">
            {"Biodiversiteit" in completedItems && <img src={boomBio} alt="Biodiversiteit" />}
            {"Hout" in completedItems && <img src={boomHout} alt="Hout" />}
            {"Ontspanning" in completedItems && <img src={boomOntspanning} alt="Ontspanning" />}
            {"Papier" in completedItems && <img src={boomPapier} alt="Papier" />}
            {"Voedsel" in completedItems && <img src={boomVoedsel} alt="Voedsel" />}
            {"Water" in completedItems && <img src={boomWater} alt="Water" />}
            {"Zuurstof" in completedItems && <img src={boomZuurstof} alt="Zuurstof" />}
          </div>
          <div className="boxes">
            {items.map(item => {
              return (
                <Box
                  key={item.name}
                  item={item}
                  onClick={() => {
                    setTooltipItem(item);
                  }}
                  isCompleted={item.name in completedItems}
                  onDrop={droppedItem => {
                    setTooltipItem("");
                    if (droppedItem.name === item.name) {
                      handleCompletedItem(item);
                    } else {
                      fout.position = item.position
                      setTooltipItem(fout);
                    }
                  }}
                />
              );
            })}
            {tooltipItem && (
              <div
                className="tooltip"
                style={{
                  position: "absolute",
                  top: tooltipItem.position.y + "px",
                  right:
                    tooltipItem.position.right + "px",
                  zIndex: "210"
                }}
              >
                {tooltipItem.description}
              </div>
            )}
          </div>
          <div className="boxes" style={{ backgroundImage: `url("${boxes}")`, zIndex: '2' }} onClick={() => {
            setTooltipItem("");
          }}></div>
        </div>
      </div>
    </div>
  );
};

export default BomenInBelgië;
